<template>
  <g>
    <polygon
      class="rightPolygon"
      :points="rightPolygon"
    />
  </g>
</template>

<script>
  export default {
    name: 'Shelf',
    props: {
      x: Number,
      y: Number,
      height: {
        type: Number,
        default: 5,
      },
      depthOffset: Object,
    },
    computed: {
      rightPolygon() {
        return `${this.x},${this.y}
          ${this.x + this.depthOffset.x},${this.y - this.depthOffset.y}
          ${this.x + this.depthOffset.x},${this.y - this.depthOffset.y - this.height}
          ${this.x},${this.y - this.height}`;
      },
    },
  };
</script>

<style scoped>
  .rightPolygon {
    fill: #DCDDDE;
  }
</style>
